import { jsx as x } from "react/jsx-runtime";
import { createContext as c, useRef as f, useEffect as p, useContext as C } from "react";
const n = c({
  enableSplunk: !0
}), P = ({
  enableSplunk: r = !0,
  state: t,
  view_name: o,
  mapDocument: e,
  children: s
}) => {
  const u = f({
    enableSplunk: r,
    state: t,
    view_name: o,
    mapDocument: e
  });
  return p(() => {
    u.current = {
      enableSplunk: r,
      state: t,
      view_name: o,
      mapDocument: e
    };
  }, [r, t, o, e]), /* @__PURE__ */ x(n.Provider, { value: u.current, children: s });
}, d = () => C(n);
export {
  P as SplunkContextProvider,
  d as useSplunkContext
};
//# sourceMappingURL=index.es45.js.map
